<script setup>
import { computed } from 'vue'
import { Link, usePage } from '@inertiajs/vue3'
import DashboardLayout from '@/Layouts/DashboardLayout.vue'
import teacher from '@/routes/teacher'

const page = usePage()

const tabs = [
  { name: 'Personal Info', href: teacher.settings.personalInfo.definition.url, icon: 'person' },
  { name: 'About Me', href: teacher.settings.aboutMe.definition.url, icon: 'edit_note' },
  { name: 'Media', href: teacher.settings.media.definition.url, icon: 'perm_media' },
  { name: 'Teaching Details', href: teacher.settings.teachingDetails.definition.url, icon: 'school' },
  { name: 'Pricing', href: teacher.settings.pricing.definition.url, icon: 'payments' },
  { name: 'Availability', href: teacher.settings.availability.definition.url, icon: 'event_available' },
  { name: 'Qualifications', href: teacher.settings.qualifications.definition.url, icon: 'workspace_premium' },
  { name: 'Documents', href: teacher.settings.documents.definition.url, icon: 'upload_file' },
  { name: 'Bank Details', href: teacher.settings.bankDetails.definition.url, icon: 'account_balance' },
  { name: 'Notifications', href: teacher.settings.notifications.definition.url, icon: 'notifications' },
]

const isActive = (tab) => {
  if (!tab || !tab.href || typeof tab.href !== 'string') return false
  const currentPath = page.url.replace(/\/$/, '')
  const tabPath = tab.href.replace(/\/$/, '')
  return currentPath === tabPath || currentPath.startsWith(tabPath + '/')
}
</script>

<template>
  <DashboardLayout>
    <!-- Header -->
    <div class="border-b border-gray-200 pb-6 mb-6">
      <h1 class="text-3xl font-bold text-gray-900">Tutor Settings</h1>
      <p class="text-gray-600 mt-2">Manage your profile, subjects, availability, and payment information</p>
    </div>

    <!-- Grid Layout: Settings Menu (1 col) + Forms (3 cols) -->
    <div class="grid grid-cols-1 md:grid-cols-4 gap-6">
      <!-- Settings Menu - 1 col -->
      <aside class="col-span-1">
        <nav class="space-y-1 flex flex-row md:flex-col overflow-x-auto scrollbar-hide pb-2 md:pb-0">
          <Link
            v-for="tab in tabs"
            :key="tab.name"
            :href="tab.href"
            :class="[
              'group flex flex-nowrap flex-shrink-0 items-center px-3 py-2.5 text-sm rounded-lg transition-all',
              isActive(tab)
                ? 'bg-gray-100 text-gray-900 font-semibold'
                : 'text-gray-600 font-medium hover:bg-gray-50 hover:text-gray-900'
            ]"
          >
            <span
              :class="[
                'material-symbols-outlined mr-3 text-xl',
                isActive(tab) ? 'text-gray-700' : 'text-gray-400 group-hover:text-gray-500'
              ]"
            >
              {{ tab.icon }}
            </span>
            {{ tab.name }}
          </Link>
        </nav>
      </aside>

      <!-- Main Forms Content - 3 cols -->
      <main class="md:col-span-3">
        <slot />
      </main>
    </div>
  </DashboardLayout>
</template>
